// extracted by mini-css-extract-plugin
export default {"summaryBox":"SummaryBox_summaryBox__xPs0Y","rightBorder":"SummaryBox_rightBorder__1EbD9"};